import { FormEvent, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { site } from "../../data/site";

export function Header() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  function handleSearch(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const nextQuery = query.trim();
    if (nextQuery) {
      navigate(`/search?q=${encodeURIComponent(nextQuery)}`);
    }
  }

  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <div className="site-header__inner">
        <Link className="brand" to="/" aria-label={`${site.name} home`}>
          <img src="/images/yawiki-logo.svg" alt="" width="42" height="42" />
          <span>{site.name}</span>
        </Link>
        <form className="site-search" onSubmit={handleSearch} role="search">
          <label className="visually-hidden" htmlFor="site-search-input">
            Search yawiki.org
          </label>
          <input
            id="site-search-input"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search articles"
            type="search"
          />
          <button type="submit">Search</button>
        </form>
        <nav className="top-nav" aria-label="Primary navigation">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/search">Search</NavLink>
          <NavLink to="/about">About</NavLink>
        </nav>
      </div>
    </header>
  );
}
